import React, { PropsWithChildren, createElement, useState, useRef, useEffect } from 'react';
import { useWindowDimensions, TextInput, Text, View, Pressable, StyleProp, ViewStyle, Platform } from 'react-native';
import CreateResponsiveStyle from '../utils/responsiveStyle';
import {GlobalVariables} from '../utils/globalVariables';
import CurrencyInput from 'react-native-currency-input';
import { DateTimePicker } from '../utils/tranformClass';
import moment from 'moment';
export enum enumTypeInput {
  text = 'text',
  number = 'number',
  date = 'date',
  decimal = 'decimal'
}
type SectionProps = PropsWithChildren<{
  type?: enumTypeInput,
  value?: any,
  title?:string
  placeHolder?: string,
  onInput?: any,
  required?: boolean,
  disabled?: boolean,
  style?: StyleProp<ViewStyle>,
  buttonLarge?: boolean,
  upperCase?: boolean,
  maxLength?: number
}>;

function InputComponent({ value, onInput, type = enumTypeInput.text, title, required = false, disabled = false, style, buttonLarge = true, placeHolder, upperCase = false, maxLength }: SectionProps): JSX.Element {
  let newValue = (value || value === 0) ? value : '';
  const firstValueTextDate = (type === enumTypeInput.date && newValue) ? moment(newValue).format('DD/MM/YYYY') : '';
  const layout = useWindowDimensions();
  const timeoutEditing = useRef<any>(null);
  const styles = responsiveStyle(layout);
  const [valueInput, setValueInput] = useState(newValue);
  const [valueInputTextDate, setValueInputTextDate] = useState(firstValueTextDate);
  const [statePressable, setStatePessable] = useState('');
  const [showPickerMobile, setShowPickerMobile] = useState(false);
  useEffect(() => {
	if (value !== undefined && value !== null) {
      setValueInput(value);
	}
  }, [value]);
  const rederInput = () => {
    //retornamos tipo date
    if (type === enumTypeInput.date) {
      if (Platform.OS === 'web') {
        return (
          createElement('input', {
            type: 'date',
            disabled: disabled,
            value: valueInput ? moment(valueInput).format('YYYY-MM-DD') : '',
            placeholder: placeHolder,
            style: styles('input'),
            onInput: (target:any) => {
              let date = moment(target.currentTarget.value).toDate();
              setValueInput(date);
              if (onInput) {
                onInput(date);
              }
            },
          })
        );
      }
      return (
        <>
          {showPickerMobile && (
            <DateTimePicker
              testID="dateTimePicker"
              value={valueInput || new Date()}
              mode={'date'}
              is24Hour={true}
              onChange={(event:any, date:any)=>{
                setShowPickerMobile(false);
                setValueInput(date);
                setValueInputTextDate(moment(date).format('DD/MM/YYYY'));
                if (onInput) {
                  onInput(date);
                }
              }}
            />
          )}
          <Pressable onPress={() => {
            if (!disabled) {
              setShowPickerMobile(!showPickerMobile);
				}
          }}>
            <TextInput
              placeholder={placeHolder}
              style={styles('input')}
              value={valueInputTextDate}
              editable={false}
            />
          </Pressable>
        </>
      );
    }
    //retornamos tipo decimal
    if (type === enumTypeInput.decimal) {
      return (
        <CurrencyInput
          style={styles('input')}
          value={valueInput}
          maxLength={maxLength}
          placeholder={placeHolder}
          placeholderTextColor={'#ccc'}
          precision={2}
          prefix="$"
          delimiter=","
          separator="."
          editable={!disabled}
				onChangeValue={(value:any)=>{
            clearTimeout(timeoutEditing.current);
            setValueInput(value);
            timeoutEditing.current = setTimeout(()=>{
              if (onInput) {
                onInput(value);
              }
            }, 200);
          }}
        />
      );
    }
    //retornamos tipo text
    return (
      <TextInput
        style={styles('input')}
        value={valueInput}
        autoCapitalize = {upperCase ? 'characters' : 'none'}
        placeholder={placeHolder}
        editable={!disabled}
        inputMode={type === enumTypeInput.number ? 'numeric' : 'text'}
        placeholderTextColor={'#ccc'}
        maxLength={maxLength}
        keyboardType={Platform.OS === 'ios' ? 'default' : 'visible-password'}
			onChangeText={(value: string) => {
          clearTimeout(timeoutEditing.current);
//amr     let newValue:any = '';
          newValue = '';
          switch (type) {
            case enumTypeInput.number:
              newValue = value.replace(GlobalVariables.patterns.number, '');
            break;
            default:
              newValue = upperCase && Platform.OS === 'web' ? value.toUpperCase() : value;
            break;
          }
          setValueInput(newValue);
          timeoutEditing.current = setTimeout(()=>{
            if (onInput) {
              onInput(newValue);
            }
          }, 200);
        }} />
    );
  };
  return (
    <View style={[styles('container'), style]}>
      { title && (
        <Text style={[
          styles('title'),
          disabled && styles('disabled'),
        ]}>
          {
            required ?
              <Text style={styles('required')}>*</Text>
              : '' //amr null
          }
          {
            title ?
              `${title}`
              : ''
          }
        </Text>)
      }
      <Pressable
        disabled={disabled}
        onHoverIn={() => setStatePessable('hovered')}
        onHoverOut={() => setStatePessable('none')}
        onPressIn={() => setStatePessable('pressed')}
        onPressOut={() => setStatePessable('pressed')}
        style={[
          styles('pressable'),
          title && { marginTop: 5 },
          buttonLarge && styles('inputWidth'),
          statePressable === 'hovered' && styles('hoverInput'),
          disabled && styles('disabled'),
        ]}
      >
        {
          rederInput()
        }

      </Pressable>
    </View>
  );
}
const responsiveStyle = CreateResponsiveStyle({
  container: {

  },
  title: {
    fontFamily: '"Helvetica Neue LT Std 75 Bold", sans-serif',
    color: GlobalVariables.colors.primary.textColorBlue,
    fontSize: 16,
    lineHeight: 23,
    fontWeight: 'bold',
  },
  input: {
    borderColor: GlobalVariables.colors.secondary.lightGrey,
    fontSize: 16,
    borderWidth: 1,
    fontFamily: 'sans-serif',
    paddingTop: 12,
    paddingBottom: 12,
    paddingRight: 15,
    paddingLeft: 15,
    borderRadius: 8,
    borderStyle: 'solid',
    color: '#404040',
  },
  inputWidth: {
    width: '100%',
  },
  hoverInput: {
    backgroundColor: GlobalVariables.colors.secondary.white,
  },
  pressable: {
    backgroundColor: GlobalVariables.colors.secondary.lightGrey,
    borderRadius: 8,
  },
  required: {
    fontFamily: '"Helvetica Neue LT Std 75 Bold", sans-serif',
    fontSize: 16,
    lineHeight: 23,
    color: GlobalVariables.colors.secondary.brightBlue,
  },
  disabled: {
    opacity: 0.7,
    ...Platform.select({
      web: {
        cursor: 'default',
      },
    }),
  },
}, {
});
export default InputComponent;
